// extracted by mini-css-extract-plugin
export var activityContainer = "_nu-0";
export var typingIndicatorContainer = "_nu-1";
export var typingIndicatorDot = "_nu-2";
export var wave = "_nu-3";